import {
    Flex,
    Spacer,
    IconButton,
    Icon,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    useDisclosure,
    Text,
    Stack,
    DrawerCloseButton,
    Avatar,
    DrawerHeader,
    DrawerBody,
    Box,
    Heading,
    Tooltip,
    Button,
    DrawerFooter,
    useColorModeValue, // Asegúrate de que esté importado
    HStack,
    Link,
    Image,
    Menu
} from "@chakra-ui/react";
import { RiFullscreenExitLine, RiFullscreenFill } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { FaCog } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { ColorModeSwitcher } from "../../theme/ColorModeSwitcher";
import { logout } from "../../features/authSlice";
import { RiMenuFoldLine, RiMenuUnfoldLine } from 'react-icons/ri';
import logo from '../../assets/img/green-technology.png'

// Importa los mismos iconos que usas en Sidebar.jsx
import { FaChalkboardTeacher, FaChartPie, FaClipboardCheck, FaQuoteRight, FaUsers, FaVest, FaMapMarkedAlt, FaMapMarkerAlt, FaMap} from "react-icons/fa";
import { RiBook3Fill, RiComputerFill, RiHomeSmile2Line, RiMapPin4Fill, RiUserStarFill, RiMoneyDollarBoxLine } from "react-icons/ri";
import { MdGrade,MdAddChart, MdMonetizationOn, MdScience, MdSettings, MdTableChart, MdPersonOutline, MdAssignment, MdPersonAdd, MdOutlineAccountTree, MdOutlineAddModerator, MdAccessibility } from "react-icons/md";
import { FcPieChart } from "react-icons/fc";
import { fetchMenu } from '../../features/menuSlice';
import { ToastChakra } from "../../helpers/toast";

// Define los mismos iconos que usas en Sidebar.jsx
const icons = {
    RiHomeSmile2Line: RiHomeSmile2Line,
    FaUsers: FaUsers,
    RiUserStarFill: RiUserStarFill,
    FaChalkboardTeacher: FaChalkboardTeacher,
    MdMonetizationOn: MdMonetizationOn,
    RiComputerFill: RiComputerFill,
    RiBook3Fill: RiBook3Fill,
    MdTableChart: MdTableChart,
    FaVest: FaVest,
    FaClipboardCheck: FaClipboardCheck,
    MdGrade: MdGrade,
    FaQuoteRight: FaQuoteRight,
    MdSettings: MdSettings,
    RiMapPin4Fill: RiMapPin4Fill,
    MdScience: MdScience,
    FcPieChart: FcPieChart,
    FaChartPie: FaChartPie,
    RiMoneyDollarBoxLine: RiMoneyDollarBoxLine,
    FaMapMarkedAlt: FaMapMarkedAlt,
    FaMapMarkerAlt: FaMapMarkerAlt,
    FaMap: FaMap,
    MdPersonOutline: MdPersonOutline,
    MdAssignment: MdAssignment,
    MdPersonAdd: MdPersonAdd,
    MdOutlineAccountTree: MdOutlineAccountTree,
    MdOutlineAddModerator: MdOutlineAddModerator,
    MdAccessibility: MdAccessibility,
    MdAddChart: MdAddChart
};

// Componente NavItem para reutilizar en el Drawer, similar al de Sidebar
export const NavItem = ({ icon, children, isSelected, ...rest }) => {
    // Declara las variables con useColorModeValue al principio del componente NavItem
    const bgActiveLinkColor = useColorModeValue("gray.200", "#151822");
    const activeLinkcolor = useColorModeValue("primary.100", "blue.600");
    const hoverBgColor = useColorModeValue("gray.100", "gray.700");
    const defaultTextColor = useColorModeValue("#6c737f", "gray.400");


    return (
        <Flex
            align="center"
            py="7px"
            borderRadius={'lg'}
            px={"4px"}
            cursor="pointer"
            _hover={{
                bg: hoverBgColor, // Usa la variable declarada
            }}
            bg={isSelected ? bgActiveLinkColor : "transparent"}
            color={isSelected ? activeLinkcolor : defaultTextColor}
            role="group"
            transition=".1s ease"
            {...rest}
        >
            {icon && (
                <Icon
                    mx="4"
                    ml={{ base: "1", md: "3" }}
                    fontSize="23px"
                    as={icon}
                    color={isSelected ? activeLinkcolor : "inherit"}
                    {...rest}
                />
            )}
            {children}
        </Flex>
    );
};

function Header({ onToggle, isOpen }) {

    const sidebar = useDisclosure();
    const dispatch = useDispatch();
    const { menu, status } = useSelector((state) => state.menu);
    const { rol } = useSelector((state) => state.auth);
    const rolKey = rol;
    const [isSpanded, setIsSpanded] = useState(false);

    const user = useSelector(state => state.auth.user);

    // Declara las variables con useColorModeValue al principio del componente Header
    const activeLinkcolor = useColorModeValue("primary.100", "primary.100");
    const bgActiveLinkColor = useColorModeValue("#dcdee1", "#151822");
    const drawerBgColor = useColorModeValue("white", "primary.1100"); // Variable para el background del DrawerContent


    const handleFullScreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
            setIsSpanded(false);
        } else {
            document.documentElement.requestFullscreen();
            setIsSpanded(true);
        }
    }

    const permisosPorRol = {
        admin: ['*'],
        operador: [
            'ver_modulo_inicio',
            'ver_modulo_servicio',
            'ver_modulo_ciudad',
            'ver_modulo_configuraciones',
            'ver_modulo_cliente',
            'ver_modulo_factura',
            'ver_modulo_presupuesto'
        ]
    }

    const tienePermiso = (key) => {
        const permisos = permisosPorRol[rolKey] || [];
        return permisos.includes('*') || permisos.includes(key);
    };


    const menuFiltrado = menu.filter((item) => tienePermiso(item.key));

    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchMenu());
        }
    }, [dispatch, status]);


    return (
        <Flex
            as="header"
            _dark={{
                bgColor: "rgba(11,15,25, 0.8)",
                color: "primary.100",
                backdropBlur: "blur(50px)"
            }}
            bg="rgba(248, 249, 250, 0.8)"
            backdropFilter="blur(10px)"
            position={{
                base: "fixed",
                lg: "sticky"
            }}
            ml={{
                base: 0,
                lg: isOpen ? "280px" : "0"
            }}
            top="0"
            left="0"
            right="0"
            zIndex="sticky"
            px={5}
            py={3}
            align="center"
            justify="space-between"
            transition=".08s ease-out"
        >
            <IconButton
                display={{
                    base: "none",
                    lg: "inline-flex"
                }}
                size={'md'}
                rounded={'full'}
                onClick={() => { onToggle(); }}
                variant="ghost"
                colorScheme="gray"
                aria-label="Toggle navigation"
                transition=".08s ease-out"
                icon={<Icon fontSize={24} as={
                    isOpen ? RiMenuFoldLine : RiMenuUnfoldLine
                } />}
                mr={2}
            />

            <Spacer />

            <Drawer
                isOpen={sidebar.isOpen}
                onClose={sidebar.onClose}
                placement="left"
                size="xs"
            >
                <DrawerOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <DrawerContent
                    bg={drawerBgColor} // Usa la variable declarada para el background
                    display="flex"
                    w="full"
                    h="full"
                    overflowY="auto"
                >
                    <Stack
                        spacing={1}
                        px={4}
                        py={2}
                        w="full"
                    >
                        <Flex
                            direction="row"
                            py={4}
                            mb={2}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                        >
                            <Stack alignItems={'center'} direction='row' spacing={4} w="full">
                                <Box
                                    w="40px"
                                    h="40px"
                                    borderRadius="lg"
                                    borderColor={'gray.200'}
                                    _dark={{
                                        borderColor: 'gray.700'
                                    }}
                                    borderWidth="1px"
                                    p={'4px'}
                                >
                                    <Image
                                        src={logo}
                                        alt="logo"
                                        w="full"
                                        alignSelf={'center'}
                                        h="full"
                                        objectFit="cover"
                                    />
                                </Box>
                                <Stack direction="column" spacing={0}>
                                    <Heading
                                        fontSize="16px"
                                        fontWeight="bold"
                                        color="primary.100"
                                        _dark={{
                                            color: "white"
                                        }}
                                        alignSelf={'start'}
                                        justifySelf={'start'}
                                        textAlign="start"
                                    >
                                        SIGNIA
                                    </Heading>
                                    <Text
                                        fontSize="14px"
                                        color="gray.500"
                                        _dark={{
                                            color: "gray.400"
                                        }}
                                        alignSelf={'start'}
                                        justifySelf={'start'}
                                        textAlign="start"
                                    >
                                    </Text>
                                </Stack>
                            </Stack>
                            <Menu>

                            </Menu>
                        </Flex>
                        {/* Mapeo de los menús dinámicos con iconos */}
                        {menuFiltrado.map((item, index) => {
                            const isSelected = item.url === window.location.pathname;
                            return (
                                <Link
                                    key={index}
                                    as={NavLink}
                                    to={item.url}
                                    fontSize={'15px'}
                                    fontWeight={'semibold'}
                                    color={'gray.400'}
                                    borderRadius={'lg'}
                                    mb={1}
                                    _activeLink={{
                                        color: activeLinkcolor,
                                        bg: bgActiveLinkColor,
                                        _dark: {
                                            color: 'blue.600'
                                        }
                                    }}
                                    _hover={{ textDecoration: 'none' }}
                                >
                                    <NavItem isSelected={isSelected} icon={icons[item.icono]}>{item.nombre}</NavItem>
                                </Link>
                            )
                        })}

                        {/* Agrega el enlace a Configuraciones si es necesario, similar a Sidebar */}
                        <Link
                            as={NavLink}
                            to="/configuraciones"
                            fontSize={'15px'}
                            fontWeight={600}
                            color={'gray.400'}
                            _dark={{
                                color: 'gray.400',
                            }}
                            borderRadius={'lg'}
                            mb={1}
                            _activeLink={{
                                color: activeLinkcolor,
                                bg: bgActiveLinkColor,
                                _dark: {
                                    color: 'blue.600'
                                }
                            }}
                            _hover={{ textDecoration: 'none' }}
                        >
                            <NavItem isSelected={"/configuraciones" === window.location.pathname} icon={FaCog}>Configuraciones</NavItem>
                        </Link>

                    </Stack>
                </DrawerContent>
            </Drawer>

            <IconButton
                aria-label="Menu"
                display={{ base: "flex", lg: "none" }}
                onClick={sidebar.onOpen}
                fontSize="2xl"
                variant="ghost"
                rounded={'full'}
                icon={<HamburgerIcon />}
            />

            <Flex alignSelf="center" verticalAlign={'center'} justify={'flex-end'} justifyContent={"flex-end"} w={'full'} display="inline-flex">
                <HStack spacing={4}>
                    <IconButton
                        aria-label="Full Screen"
                        fontSize="xl"
                        variant="ghost"
                        rounded={'full'}
                        icon={isSpanded === true ? <RiFullscreenExitLine /> : <RiFullscreenFill />}
                        colorScheme="gray"
                        onClick={handleFullScreen}
                    />
                    <ColorModeSwitcher />
                    <DrawerExample user={user?.usuario} />
                </HStack>
            </Flex>
        </Flex>
    );
}

export default Header;

function DrawerExample({ user }) {

    const { isOpen, onOpen, onClose } = useDisclosure()
    const firstField = useRef();
    const dispatch = useDispatch();

    // Recupera el usuario desde el localStorage
    const usere = JSON.parse(localStorage.getItem('user'));
    const email = usere?.usuario?.email;
    const nombre = usere?.usuario?.persona.nombre;
    const apellido = usere?.usuario?.persona.apellido;
    const rol = usere?.usuario?.rol.descripcion;

    const lightenDarkenColor = (colorCode, amount) => {

        let usePound = false;

        if (colorCode[0] === "#") {
            colorCode = colorCode.slice(1);
            usePound = true;
        }
        const num = parseInt(colorCode, 16);
        let r = (num >> 16) + amount;

        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }

        let b = ((num >> 8) & 0x00FF) + amount;

        if (b > 255) {
            b = 255;
        } else if (b < 0) {
            b = 0;
        }

        let g = (num & 0x0000FF) + amount;

        if (g > 255) {
            g = 255;
        } else if (g < 0) {
            g = 0;
        }
        let color = (g | (b << 8) | (r << 16)).toString(16);
        while (color.length < 6) {
            color = 0 + color;
        }
        return (usePound ? '#' : '') + color;
    }

    const bgColorModified = lightenDarkenColor(user?.brand_color || '#000000', - 80);
    const bgTransparency = useColorModeValue('rgba(0, 0, 0, .07)', 'rgba(255, 255, 255, .1)');

    const handleLogout = () => {
        dispatch(logout());
        ToastChakra('CERRANDO SESIÓN ...', 'HASTA PRONTO, TE ESPERAMOS!', 'loading', 2000);
    }

    return (
        <>
            <Avatar
                // src={user?.img}
                name={user?.nombre}
                ignoreFallback={true}
                onClick={onOpen}
                borderColor={bgColorModified}
                color={'white'}
                fontWeight={'bold'}
                fontSize={'md'}
                size={'sm'}
                rounded="full"
                cursor={'pointer'}
            />

            <Drawer
                isOpen={isOpen}
                placement='right'
                initialFocusRef={firstField}
                onClose={onClose}
                size={'sm'}
            >
                <DrawerOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <DrawerContent>
                    <DrawerCloseButton size={'lg'} mt={1} />
                    <DrawerHeader borderBottomWidth='1px' _dark={{ bg: 'primary.1100' }}>
                        Mi Perfil
                    </DrawerHeader>
                    <DrawerBody _dark={{ bg: 'primary.1100' }} bg="#f9f9f9">
                        <Box bgColor={bgColorModified} h="160px" mx={-6} />
                        <Stack direction={'row'} align={'start'} justifyContent={'space-between'}>
                            <Avatar
                                src={user?.img}
                                name={user?.nombre}
                                size={'xl'}
                                mt={-14}
                                fontWeight={'extrabold'}
                                objectFit='cover'
                                color={'white'}
                                borderWidth={6}
                                borderColor={bgTransparency}
                            />
                        </Stack>
                        <Stack mt={4} spacing={6} alignSelf={'center'}>
                            <Stack spacing={2} direction="row" justifyContent={'space-between'}>
                                <Box>
                                    <Heading fontSize='xl' fontWeight='bold' textTransform={'capitalize'}>{nombre + ' ' + apellido}</Heading>
                                    <Text fontSize='md'>{email}</Text>
                                </Box>
                                <Box alignSelf={'center'}>
                                    <Tooltip placement='left' label="Editar y Ver Detalles" aria-label="Editar y Ver Detalles" alignSelf={'center'}>
                                        <Link as={NavLink} to={'/perfil'}>
                                            <IconButton aria-label="Editar y Ver Detalles" alignSelf={'center'} rounded={'full'} variant="ghost" colorScheme="gray" icon={<FaCog size={24} />} size={'lg'} />
                                        </Link>
                                    </Tooltip>
                                </Box>
                            </Stack>

                            <Box>
                                <Stack
                                    direction={'row'}
                                    justifyContent={'space-between'}
                                    align={'center'}
                                >
                                    <Text fontSize='xl' fontWeight='bold' alignSelf={'center'}>{rol}</Text>
                                </Stack>
                            </Box>

                        </Stack>
                    </DrawerBody>

                    <DrawerFooter borderTopWidth='1px' _dark={{ bg: 'primary.1100' }} display="flex">
                        <Tooltip
                            label="Cerrar Sesión"
                            aria-label="Cerrar Sesión"
                            alignSelf={'center'}
                            placement={'top'}
                        >
                            <Button rightIcon={<FiLogOut />} w="full" bg='red.500' _hover={{ bg: 'red.700', color: 'white' }} color='white' _dark={{ bg: 'red.500', _hover: { bg: 'red.700', color: 'white' } }} rounded={'xl'} onClick={handleLogout}>
                                Cerrar Sesión
                            </Button>
                        </Tooltip>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    )
}